import React, {Component} from 'react';
import Container from '../container/Container'
import './SuperAdminStyle.scss'
import {CollapsedSidebar} from "@moeindal/base-raiko-panel-components";
import {advanceSidebarItems} from "../component/Sidebar/SideBarItems";
import {useAuthState} from "../context/AuthContext";
import brandLogo from "../assets/images/saman-logo.png"

export const SuperAdmin = () => {
    const {role: roles} = useAuthState();


    return (
        <section className="main-division">
            <div className={"mainDivisionSidebarContainer"}>
                <CollapsedSidebar
                    advanceSidebarItems={advanceSidebarItems}
                    roles={roles}
                    hasBrand
                    brandTitle={"SAMAN"}
                    brandImage={brandLogo}
                    brandUrlAddress={"https://sandooghmn.ir"}
                />

            </div>
            <Container/>
        </section>
    )
}
